import Vue from 'vue';
import * as filters from '@/filters';
import { initAdapter, getAdapter } from '@zyf2e/adapt';
import * as Telescope from '@zyf2e/telescope';
import { getUrlParam } from './utils';
import globalComponents from '@/components/index';

import App from './App.vue';
import router from './router';
import store from './store';
import './styles/index.less';

// 组件统一引入
import '@/utils/capsule-ui-use';

// 注册全局组件
Object.keys(globalComponents).forEach(key => {
  Vue.component(key, globalComponents[key]);
});

// 注入filter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

Vue.config.productionTip = false;

Vue.prototype.telescope = Telescope;

Vue.directive('track-event', Telescope.vTrackEvent);
Telescope.setConfig({
  autoTrackClick: false,
  trackKey: 'acd2bf9921d1c93e260c4626e1a7d88b',
  version: '1.0.0'
});

router.beforeEach(async (to, from, next) => {
  if (to.meta.telescope) {
    Telescope.trackPage({ trackId: to.meta.telescope });
  }
  next();
});

async function main() {
  const channelCode = getUrlParam('channelCode');
  await initAdapter({
    baseURL: process.env.VUE_APP_API,
    h5LoginUrl: `${process.env.VUE_APP_STATICE}/collection/login2/dist/index.html#/login?channelCode=${channelCode}&redirect=`
  });
  Vue.prototype.adapt = getAdapter();
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
}

main();
